import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'filterModal.close',
    defaultMessage: 'Close',
  },
  clear: {
    id: 'filterModal.clear',
    defaultMessage: 'Clear',
  },
  done: {
    id: 'filterModal.done',
    defaultMessage: 'Done',
  },
});
